<template>
  <v-container fluid>
    <v-card outlined>
      <v-card-title>{{ happ[0].HappName }}</v-card-title>
      <v-card-text>
        <!-- <v-form v-model="isValid"> -->
            
        <v-checkbox
          :input-value="false"
          label="Crew member"
          v-model="isCrew"
        ></v-checkbox>
        <!-- <v-card> -->
          <v-select
            v-model="classes.text"
            :items="classes"
            label="Select class"
            dense
            outlined
            @change="this.clasSelected"
            class="d-flex justify-space-around"
          ></v-select>
        <!-- </v-card> -->
        <!-- <v-divider></v-divider> -->
        <!-- <p></p> -->
        <v-divider></v-divider>
        <p></p>
        <v-row>
          <v-col> </v-col>
          <v-col class="d-flex">
            <v-btn
              color="primary"
              rounded
              :disabled="submitDisabled"
              @click="this.submit"
              small
              >SUBMIT</v-btn
            >
          </v-col>
          <v-col>
            <v-btn small rounded color="lightgrey" link :to="toEvent">Cancel</v-btn>
          </v-col>
        </v-row>

        <!-- </v-form> -->
      </v-card-text>
    </v-card>
    <p></p>
    <div class="text-center">
    <v-bottom-sheet
      v-model="sheet"
      inset
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="orange"
          dark
          v-bind="attrs"
          v-on="on"
          small
        >
          Info
        </v-btn>
      </template>
      <v-sheet
        class="text-center"
        height="400px"
      >
        <v-btn
          class="mt-6"
          text
          color="error"
          @click="sheet = !sheet"
        >
          close
        </v-btn>
        <div class="my-3">
          <v-textarea value="
              Crew member: Tick this if you are
              part of the staff, driver, manager etc.
              A crew member may also participate/fly
              in the event.

              Classes: Used in competition events.
              Depend on glider category.

              Open: CCC and D.
              Sport: C.
              Fun: A and B.

              Other: If none of the above is relevant.
              
              Crew: Crew member only. Select this if 
              you don't participate as pilot.
              "
              >
          </v-textarea>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>

    <div>
      <v-alert type="success" :value="isAlertVisible">
        {{ statusResultMsg }}
      </v-alert>
      <v-alert type="warning" :value="isWarningAlertVisible">
        {{ statusResultMsg }}
      </v-alert>
      <div
        v-if="isAlertVisible || isWarningAlertVisible"
        class="d-flex justify-center"
      >
        <v-btn color="primary" rounded :to="toEvent">OK</v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "HappDetails",
  props: {
    happ: {
      type: Array,
    },
    regId: Number,
    ac: String,
  },
  data() {
    return {
      //   search: "",
      items: [],
      loading: true,
      //   classes: ["Open", "Sport", "Fun", "Other", "Crew"],
      classes: [
        { text: "Open", value: 1 },
        { text: "Sport", value: 2 },
        { text: "Fun", value: 3 },
        { text: "Other", value: 4 },
        { text: "Crew", value: 5 },
      ],
      submitDisabled: true,
      isCrew: false,
      isAlertVisible: false,
      isWarningAlertVisible: false,
      statusResult: Number,
      statusResultMsg: String,
      toEvent: String,
      sheet: false
    };
  },
  created() {
    //
    this.items = this.happ;
    this.loading = false;
    this.classes.text = "Open";
    this.classes.value = 1;
    this.statusResult = null;
    this.statusResultMsg = null;
    this.toEvent = "/eventlist"; // + this.happ[0].HappId;
    // this.submitDisabled = false;
    // console.log("In component",this.happ);
  },
  methods: {
    clasSelected() {
      console.log("selected", this.classes.text);
      this.submitDisabled = false;
    },
    submit() {
      var happId = this.happ[0].HappId;
      var regId = this.regId;
      var ac = this.ac;
      var classId = this.classes.text;
      var isCrew = this.isCrew;
      var toSubmit = { happId, regId, ac, classId, isCrew };
      this.submitDisabled = true;
      //   console.log("toSubmit", toSubmit);
      //this.baseUrl = 'http://localhost:3000/dbapi/' //https://pgbox.azurewebsites.net:3000/
      const baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
      this.postRegistration(baseUrl + "happpilotreg", toSubmit);
    },
    postRegistration(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.statusResult = response.data[0].Result;
          this.statusResultMsg = response.data[0].ResultMsg;
          this.setAlert(this.statusResult);
          // if(this.statusResultMsg == 1) {
          // something
          // }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setAlert(statusResult) {
      if (statusResult == 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult == 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
  },
};
</script>
